
<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">

    <span class="panel-title" *ngIf="!activityTypeId">{{'app.create' | translate}}</span>
    <span class="panel-title" *ngIf="activityTypeId">{{'app.editTile' | translate}}</span>
  </div>

  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="container text-center" *ngIf="displayMode==1">
        <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
      </div>

      <form #f="ngForm" *ngIf="displayMode==2"
            novalidate (ngSubmit)="save(f)">
        <div class="row padding-sm-vr">
          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (name.dirty || name.touched || f.submitted)  && name.valid, 'has-error' : (name.dirty || name.touched || f.submitted)  && name.invalid}">
              <label class="control-label">{{'app.name' | translate}} </label>
              <input type="text"
                     name="name"
                     [(ngModel)]="activitytype.name"
                     #name="ngModel"
                     required="required"
                     class="form-control" />
              <div *ngIf="(name.dirty || name.touched || f.submitted)  && name.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (leadTime.dirty || leadTime.touched || f.submitted)  && leadTime.valid, 'has-error' : (leadTime.dirty || leadTime.touched || f.submitted)  && leadTime.invalid}">
              <label class="control-label">{{'repActivities.leadtime' | translate}} </label>
              <input type="number"
                     name="leadTime"
                     [(ngModel)]="activitytype.leadTime"
                     #leadTime="ngModel"
                     required="required"
                     class="form-control" />
              <div *ngIf="(leadTime.dirty || leadTime.touched || f.submitted)  && leadTime.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>


        </div>
        <div class="row padding-sm-vr">
          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (confirmedDeadline.dirty || confirmedDeadline.touched || f.submitted)  && confirmedDeadline.valid, 'has-error' : (confirmedDeadline.dirty || confirmedDeadline.touched || f.submitted)  && confirmedDeadline.invalid}">
              <label class="control-label">{{'repActivities.confirmedDeadline' | translate}} </label>
              <input type="number"
                     name="confirmedDeadline"
                     [(ngModel)]="activitytype.confirmedDeadline"
                     #confirmedDeadline="ngModel"
                     required="required"
                     class="form-control" />
              <div *ngIf="(confirmedDeadline.dirty || confirmedDeadline.touched || f.submitted)  && confirmedDeadline.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-6" *ngIf="activitytype.isServiceRequest">
            <div [ngClass]="{'has-success': (maxNoOfInvi.dirty || maxNoOfInvi.touched || f.submitted)  && maxNoOfInvi.valid, 'has-error' : (maxNoOfInvi.dirty || maxNoOfInvi.touched || f.submitted)  && maxNoOfInvi.invalid}">
              <label class="control-label">{{'repActivities.maxNoOfInvitees' | translate}} </label>
              <input type="number"
                     name="maxNoOfInvi" required="required"
                     [(ngModel)]="activitytype.maxNoOfInvitees" min="1"
                     #maxNoOfInvi="ngModel"
                     class="form-control" />
              <div *ngIf="(maxNoOfInvi.dirty || maxNoOfInvi.touched || f.submitted)  && maxNoOfInvi.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
        </div>
        <div class="row padding-sm-vr">
          <div class="col-sm-6" *ngIf="activityGroups && activityGroups.length>0">
            <div [ngClass]="{'has-success': (activityGrou.dirty || activityGrou.touched || f.submitted)  && activityGrou.valid, 'has-error' : (activityGrou.dirty || activityGrou.touched || f.submitted)  && activityGrou.invalid}">

              <label class="control-label">{{'repActivities.activityGroups' | translate}} </label>
              <span class="ui-fluid">
                <p-dropdown [options]="activityGroups"
                            name="activityGrou" #activityGrou="ngModel"
                            styleClass="wid100"
                            placeholder="Activity Groups"
                            emptyFilterMessage="No results found" required="required"
                            showClear="true"
                            [(ngModel)]="activitytype.activityGroup"
                            [virtualScroll]="true" itemSize="10"
                            [filter]="true" optionLabel="name"></p-dropdown>

              </span>
              <div *ngIf="(activityGrou.dirty || activityGrou.touched || f.submitted)  && activityGrou.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-6" *ngIf="activityCostCenters && activityCostCenters.length>0&& applyCosteCenter == 'True'">
            <div [ngClass]="{'has-success': (activityCostCen.dirty || activityCostCen.touched || f.submitted)  && activityCostCen.valid, 'has-error' : (activityCostCen.dirty || activityCostCen.touched || f.submitted)  && activityCostCen.invalid}">

              <label class="control-label">{{'repActivities.activityCostCenter' | translate}} </label>
              <ng-multiselect-dropdown [placeholder]="'Activity Cost Center'"
                                       [data]="activityCostCenters"
                                       name="activityCostCen" #activityCostCen="ngModel"
                                       [(ngModel)]="activitytype.activityCostCenter"
                                       [settings]="dropdownSettings">
              </ng-multiselect-dropdown>

              <div *ngIf="(activityCostCen.dirty || activityCostCen.touched || f.submitted)  && activityCostCen.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
        </div>

        <div class="row padding-sm-vr">
          <div class="col-sm-6" *ngIf="activityCostTypes && activityCostTypes.length>0">
            <div [ngClass]="{'has-success': (activityCostTy.dirty || activityCostTy.touched || f.submitted)  && activityCostTy.valid, 'has-error' : (activityCostTy.dirty || activityCostTy.touched || f.submitted)  && activityCostTy.invalid}">

              <label class="control-label">{{'repActivities.activityCostType' | translate}} </label>
              <ng-multiselect-dropdown [placeholder]="'Activity Cost Type'"
                                       [data]="activityCostTypes"
                                       name="activityCostTy" #activityCostTy="ngModel"
                                       [(ngModel)]="activitytype.activityCostType"
                                       [settings]="dropdownSettings">
              </ng-multiselect-dropdown>

              <div *ngIf="(activityCostTy.dirty || activityCostTy.touched || f.submitted)  && activityCostTy.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
        </div>

        <h4>Pre {{ !activitytype.isServiceRequest ? ('mainMenu.Activity' | translate): ('mainMenu.serviceRequest' | translate)}} Approval Cycle</h4>
        <div class="row padding-sm-vr" *ngFor="let level of activitytype.firstActivityTypeApproval; let i = index">
          <div class="col-sm-2">
            <div [ngClass]="{'has-success': (lev.dirty || lev.touched || f.submitted)  && lev.valid, 'has-error' : (lev.dirty || lev.touched || f.submitted)  && lev.invalid}">
              <label class="control-label">{{'repActivities.level' | translate}} </label>

              <input class="form-control" type="number" placeholder="{{'repActivities.level' | translate}}"
                     name="lev{{i}}" #lev="ngModel" required="required" min="1"
                     [(ngModel)]="level.stepLevel">
              <div *ngIf="(lev.dirty || lev.touched || f.submitted)  && lev.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div [ngClass]="{'has-success': (approvalAct.dirty || approvalAct.touched || f.submitted)  && approvalAct.valid, 'has-error' : (approvalAct.dirty || approvalAct.touched || f.submitted)  && approvalAct.invalid}">
              <label class="control-label">{{'repActivities.type' | translate}} </label>
              <span class="ui-fluid">
                <p-dropdown [options]="activityApprovalActorkeys"
                            placeholder="{{'repActivities.type' | translate}}"
                            emptyFilterMessage="No results found" required="required"
                            styleClass="wid100"
                            [styleClass]="form-control"
                            name="approvalAct{{i}}"
                            #approvalAct="ngModel" (onChange)="onChangeApprovalActorType(level)"
                            [(ngModel)]="level.activityApprovalActorTypeData"
                            [filter]="true" optionLabel="name">


                </p-dropdown>
              </span>
              <div *ngIf="(approvalAct.dirty || approvalAct.touched || f.submitted)  && approvalAct.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-2" *ngIf="level.showUsers">
            <div [ngClass]="{'has-success': (visitAssistants.dirty || visitAssistants.touched || f.submitted)  && visitAssistants.valid, 'has-error' : (visitAssistants.dirty || visitAssistants.touched || f.submitted)  && visitAssistants.invalid}">
              <label class="control-label">{{'repActivities.users' | translate}} </label>
              <span class="ui-fluid">
                <p-dropdown [options]="users"
                            name="visitAssistants{{i}}" #visitAssistants="ngModel"
                            styleClass="wid100" required="required"
                            placeholder="User"
                            emptyFilterMessage="No results found"
                            [(ngModel)]="level.activityApprovalActorValueData"
                            [virtualScroll]="true" itemSize="10"
                            [filter]="true" optionLabel="fullName"></p-dropdown>

              </span> <div *ngIf="(visitAssistants.dirty || visitAssistants.touched || f.submitted)  && visitAssistants.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-2" *ngIf="level.showRoles">
            <div [ngClass]="{'has-success': (rol.dirty || rol.touched || f.submitted)  && rol.valid, 'has-error' : (rol.dirty || rol.touched || f.submitted)  && rol.invalid}">
              <label class="control-label">{{'repActivities.roles' | translate}} </label>
              <span class="ui-fluid">
                <p-dropdown [options]="roles"
                            name="rol{{i}}" #rol="ngModel"
                            styleClass="wid100" required="required"
                            placeholder="Role"
                            emptyFilterMessage="No results found"
                            [(ngModel)]="level.activityApprovalActorValueData"
                            [virtualScroll]="true" itemSize="10"
                            [filter]="true" optionLabel="name"></p-dropdown>

              </span> <div *ngIf="(rol.dirty || rol.touched || f.submitted)  && rol.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-2" *ngIf="level.showJobs">
            <div [ngClass]="{'has-success': (job.dirty || job.touched || f.submitted)  && job.valid, 'has-error' : (job.dirty || job.touched || f.submitted)  && job.invalid}">
              <label class="control-label">{{'repActivities.jobs' | translate}} </label>
              <span class="ui-fluid">
                <p-dropdown [options]="jobs"
                            name="job{{i}}" #job="ngModel"
                            styleClass="wid100" required="required"
                            placeholder="Job"
                            emptyFilterMessage="No results found"
                            [(ngModel)]="level.activityApprovalActorValueData"
                            [virtualScroll]="true" itemSize="10"
                            [filter]="true" optionLabel="name"></p-dropdown>

              </span> <div *ngIf="(job.dirty || job.touched || f.submitted)  && job.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div [ngClass]="{'has-success': (approvedStatus.dirty || approvedStatus.touched || f.submitted)  && approvedStatus.valid, 'has-error' : (approvedStatus.dirty || approvedStatus.touched || f.submitted)  && approvedStatus.invalid}">
              <label class="control-label">{{'repActivities.approvedStatus' | translate}} </label>

              <input class="form-control" type="text" placeholder="{{'repActivities.approvedStatus' | translate}}"
                     name="approvedStatus{{i}}" #approvedStatus="ngModel"
                     [(ngModel)]="level.approvedStatusText">
              <div *ngIf="(approvedStatus.dirty || approvedStatus.touched || f.submitted)  && approvedStatus.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div [ngClass]="{'has-success': (rejectedStatus.dirty || rejectedStatus.touched || f.submitted)  && rejectedStatus.valid, 'has-error' : (rejectedStatus.dirty || rejectedStatus.touched || f.submitted)  && rejectedStatus.invalid}">
              <label class="control-label">{{'repActivities.rejectedStatus' | translate}} </label>

              <input class="form-control" type="text" placeholder="{{'repActivities.rejectedStatus' | translate}}"
                     name="rejectedStatus{{i}}" #rejectedStatus="ngModel"
                     [(ngModel)]="level.rejectedStatusText">
              <div *ngIf="(rejectedStatus.dirty || rejectedStatus.touched || f.submitted)  && rejectedStatus.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>

          <div class="col-sm-3" style="margin-top:1%">
            <div class="pull-left">
              <div class="checkbox user-enabled">
                <label [ngClass]="{'disabled':checkAnotherFirstLevelCanAddCostDetails(level)}">
                  <input type="checkbox" name="canAddCostDetails{{i}}" [(ngModel)]="level.canAddCostDetails">
                  {{'repActivities.canAddCostDetails' | translate}}
                </label>
              </div>

            </div>
          </div>
          <div class="col-sm-3" style="margin-top:1%">
            <div class="pull-left">
              <div class="checkbox user-enabled">
                <label [ngClass]="{'disabled':checkAnotherFirstLevelCanAddDepartments(level)}">
                  <input type="checkbox" name="canAddDepartments{{i}}" [(ngModel)]="level.canAddDepartments">
                  {{'repActivities.canAddDepartments' | translate}}
                </label>
              </div>

            </div>
          </div>

          <div class="col-sm-2 left-7 cursor-pointer" style="margin-top:30px;" (click)="removeFirstLevel(i)">
            <span class="margin-right-7 create-new-span">
              Remove
            </span>
            <i class="fa fa-minus-circle"></i>
          </div>
        </div>
        <div class="row padding-xs-vr">
          <div class="col-sm-9"></div>
          <div class="col-sm-2 left-7 cursor-pointer" style="margin-top:30px;" (click)="addNewFirstLevel()">
            <span class="margin-right-7 create-new-span">Add Level</span>
            <i class="fa fa-plus-circle"></i>
          </div>
        </div>

        <h4>Post {{ !activitytype.isServiceRequest ? ('mainMenu.Activity' | translate): ('mainMenu.serviceRequest' | translate)}} Approval Cycle</h4>
        <div class="row padding-sm-vr" *ngFor="let level of activitytype.secondActivityTypeApproval; let i = index">
          <div class="col-sm-2">
            <div [ngClass]="{'has-success': (levSecond.dirty || levSecond.touched || f.submitted)  && levSecond.valid, 'has-error' : (levSecond.dirty || levSecond.touched || f.submitted)  && levSecond.invalid}">
              <label class="control-label">{{'repActivities.level' | translate}} </label>

              <input class="form-control" type="number" placeholder="{{'repActivities.level' | translate}}"
                     name="levSecond{{i}}" #levSecond="ngModel" required="required" min="1"
                     [(ngModel)]="level.stepLevel">
              <div *ngIf="(levSecond.dirty || levSecond.touched || f.submitted)  && levSecond.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div [ngClass]="{'has-success': (approvalActSecond.dirty || approvalActSecond.touched || f.submitted)  && approvalActSecond.valid, 'has-error' : (approvalActSecond.dirty || approvalActSecond.touched || f.submitted)  && approvalActSecond.invalid}">
              <label class="control-label">{{'repActivities.type' | translate}} </label>
              <span class="ui-fluid">
                <p-dropdown [options]="activityApprovalActorkeys"
                            placeholder="{{'repActivities.type' | translate}}"
                            emptyFilterMessage="No results found" required="required"
                            styleClass="wid100"
                            [styleClass]="form-control"
                            name="approvalActSecond{{i}}"
                            #approvalActSecond="ngModel" (onChange)="onChangeApprovalActorType(level)"
                            [(ngModel)]="level.activityApprovalActorTypeData"
                            [filter]="true" optionLabel="name">


                </p-dropdown>
              </span>
              <div *ngIf="(approvalActSecond.dirty || approvalActSecond.touched || f.submitted)  && approvalActSecond.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-2" *ngIf="level.showUsers">
            <div [ngClass]="{'has-success': (usreSecond.dirty || usreSecond.touched || f.submitted)  && usreSecond.valid, 'has-error' : (usreSecond.dirty || usreSecond.touched || f.submitted)  && usreSecond.invalid}">
              <label class="control-label">{{'repActivities.users' | translate}} </label>
              <span class="ui-fluid">
                <p-dropdown [options]="users"
                            name="usreSecond{{i}}" #usreSecond="ngModel"
                            styleClass="wid100" required="required"
                            placeholder="User"
                            emptyFilterMessage="No results found"
                            [(ngModel)]="level.activityApprovalActorValueData"
                            [virtualScroll]="true" itemSize="10"
                            [filter]="true" optionLabel="fullName"></p-dropdown>

              </span>
              <div *ngIf="(usreSecond.dirty || usreSecond.touched || f.submitted)  && usreSecond.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-2" *ngIf="level.showRoles">
            <div [ngClass]="{'has-success': (rolSecond.dirty || rolSecond.touched || f.submitted)  && rolSecond.valid, 'has-error' : (rolSecond.dirty || rolSecond.touched || f.submitted)  && rolSecond.invalid}">
              <label class="control-label">{{'repActivities.roles' | translate}} </label>
              <span class="ui-fluid">
                <p-dropdown [options]="roles"
                            name="rolSecond{{i}}" #rolSecond="ngModel"
                            styleClass="wid100" required="required"
                            placeholder="Role"
                            emptyFilterMessage="No results found"
                            [(ngModel)]="level.activityApprovalActorValueData"
                            [virtualScroll]="true" itemSize="10"
                            [filter]="true" optionLabel="name"></p-dropdown>

              </span> <div *ngIf="(rolSecond.dirty || rolSecond.touched || f.submitted)  && rolSecond.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-2" *ngIf="level.showJobs">
            <div [ngClass]="{'has-success': (jobSecond.dirty || jobSecond.touched || f.submitted)  && jobSecond.valid, 'has-error' : (jobSecond.dirty || jobSecond.touched || f.submitted)  && jobSecond.invalid}">
              <label class="control-label">{{'repActivities.jobs' | translate}} </label>
              <span class="ui-fluid">
                <p-dropdown [options]="jobs"
                            name="jobSecond{{i}}" #jobSecond="ngModel"
                            styleClass="wid100" required="required"
                            placeholder="Job"
                            emptyFilterMessage="No results found"
                            [(ngModel)]="level.activityApprovalActorValueData"
                            [virtualScroll]="true" itemSize="10"
                            [filter]="true" optionLabel="name"></p-dropdown>

              </span> <div *ngIf="(jobSecond.dirty || jobSecond.touched || f.submitted)  && jobSecond.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div [ngClass]="{'has-success': (approvedStatusSecond.dirty || approvedStatusSecond.touched || f.submitted)  && approvedStatusSecond.valid, 'has-error' : (approvedStatusSecond.dirty || approvedStatusSecond.touched || f.submitted)  && approvedStatusSecond.invalid}">
              <label class="control-label">{{'repActivities.approvedStatus' | translate}} </label>

              <input class="form-control" type="text" placeholder="{{'repActivities.approvedStatus' | translate}}"
                     name="approvedStatusSecond{{i}}" #approvedStatusSecond="ngModel"
                     [(ngModel)]="level.approvedStatusText">
              <div *ngIf="(approvedStatusSecond.dirty || approvedStatusSecond.touched || f.submitted)  && approvedStatusSecond.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div [ngClass]="{'has-success': (rejectedStatusSecond.dirty || rejectedStatusSecond.touched || f.submitted)  && rejectedStatusSecond.valid, 'has-error' : (rejectedStatusSecond.dirty || rejectedStatusSecond.touched || f.submitted)  && rejectedStatusSecond.invalid}">
              <label class="control-label">{{'repActivities.rejectedStatus' | translate}} </label>

              <input class="form-control" type="text" placeholder="{{'repActivities.rejectedStatus' | translate}}"
                     name="rejectedStatusSecond{{i}}" #rejectedStatusSecond="ngModel"
                     [(ngModel)]="level.rejectedStatusText">
              <div *ngIf="(rejectedStatusSecond.dirty || rejectedStatusSecond.touched || f.submitted)  && rejectedStatusSecond.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>

          <div class="col-sm-2 left-7 cursor-pointer" style="margin-top:30px;" (click)="removeSecondLevel(i)">
            <span class="margin-right-7 create-new-span">
              Remove
            </span>
            <i class="fa fa-minus-circle"></i>
          </div>
        </div>
        <div class="row padding-xs-vr">
          <div class="col-sm-9"></div>
          <div class="col-sm-2 left-7 cursor-pointer" style="margin-top:30px;" (click)="addNewSecondLevel()">
            <span class="margin-right-7 create-new-span">Add Level</span>
            <i class="fa fa-plus-circle"></i>
          </div>
        </div>

        <div class="panel-footer margin-left-20 margin-top-20 margin-left-37">
          <button class="btn  btn-cancel" type="button" (click)="back()">{{'app.cancel' | translate}}</button>&nbsp;
          <button class="btn  btn-save" type="submit">{{'app.save' | translate}}</button>
        </div>
      </form>
    </div>
  </div>

</div>

<div class="row col-sm-12 padding-sm-hr" *ngIf="displayMode==3">
  <div class="alert alert-danger alert-dark">
    <button type="button" class="close" data-dismiss="alert">×</button>
    {{'app.ServerError' |translate}}.
  </div>
</div>




